import SectionHeader from "./sectionheader";

function AI(props) {
    return (
        <div id="AI" className='nav-margin'>
            <SectionHeader capability={props.capability} section="AI" wrapper="pb-5 border-bottom border-secondary" />
        </div>
    )
}

export default AI;